import { Colors } from '../../themes/colors';
import { Platform } from 'react-native';
import { themedStyleSheet } from '../../themes/themedStyleSheet';

export const filterStyles = themedStyleSheet((role) => ({
  container: {
    flex: 1,
    justifyContent: 'flex-start',
    flexDirection: 'column',
    backgroundColor: role.surfaceHover,
    width: '100%',
  },
  toggleFilterContainer: {
    ...Platform.select({
      web: {
        marginRight: 28,
        marginBottom: 4,
      },
      default: {
        marginRight: 16,
        marginBottom: 0,
      },
    }),
    flexDirection: 'row',
    marginLeft: 12,
    marginTop: 12,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  scrollViewContainer: {
    flex: 1,
  },
  scrollViewContent: {
    backgroundColor: role.surfaceHover,
    flexGrow: 1,
    padding: 12,
  },
  groupsSection: {
    flex: 1,
    marginBottom: 8,
  },
  filterRowHeader: {
    fontSize: 16,
    fontWeight: '600',
    letterSpacing: -0.25,
    marginBottom: 12,
    marginTop: 12,
    color: role.textPrimary,
  },
  applyButtonContainer: {
    flexDirection: 'row',
    padding: 12,
  },
  applyButton: {
    borderRadius: 8,
    height: 44,
    flex: 1,
    bottom: 32,
  },
  markersContainer: {
    flex: 1,
    backgroundColor: role.surface,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: role.borderControl,
  },
  markerItemRow: {
    flex: 1,
    width: '100%',
    height: 48,
    maxHeight: 48,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    paddingLeft: 12,
    paddingRight: 4,
  },
  markerLeft: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flex: 1,
  },
  markerRight: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  markerLabel: {
    fontSize: 16,
    fontWeight: '400',
    letterSpacing: -0.25,
  },
  colorButton: {
    width: 30,
    height: 24,
    borderRadius: 4,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
  },
  colorButtonSelected: {
    borderWidth: 2,
    borderColor: role.textStrong,
  },
  rowContainer: {
    height: 44,
    marginBottom: 12,
    backgroundColor: role.surface,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: role.borderControl,
    paddingLeft: 12,
    paddingRight: 6,
  },
  rowDateFilterContainer: {
    height: 44,
  },
  checkboxLabel: {
    textAlign: 'left',
    fontSize: 16,
    fontWeight: '500',
    letterSpacing: -0.25,
    color: role.textStrong,
  },
  rowRadioButton: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  dateFilterRadioButton: {
    flexDirection: 'column',
  },
  dateFilterRowRadioButton: {
    marginBottom: 12,
    borderRadius: 8,
    borderWidth: 1,
    paddingLeft: 12,
    paddingRight: 6,
    flexDirection: 'column',
    backgroundColor: role.surface,
    borderColor: role.borderControl,
  },
  renderCustomDate: {
    flexDirection: 'row',
  },
  labelPill: {
    backgroundColor: role.surfaceHover,
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 15,
    alignSelf: 'flex-start',
  },
  labelPillText: {
    fontSize: 14,
    lineHeight: 16,
    color: role.textStrong,
    fontWeight: '400',
  },
  dateRangeContainer: {
    ...Platform.select({
      web: {
        flexDirection: 'column',
        gap: 12,
      },
    }),
  },
  editInput: {
    borderWidth: 1,
    borderColor: role.borderControl,
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    fontSize: 16,
    color: role.textStrong,
  },
  categoryNameContainer: {
    flex: 1,
    paddingVertical: 4,
  },
  // Edit modal styles
  editItemModalOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
  },
  editItemModal: {
    position: 'absolute',
    width: 260,
  },
  editItemModalContainer: {
    backgroundColor: role.surface,
    borderRadius: 8,
    shadowColor: Colors.black,
    shadowOpacity: 0.08,
    shadowRadius: 12,
    elevation: 6,
  },
  editItemTextContainer: {
    padding: 12,
  },
  editItemTitle: {
    marginBottom: 10,
    color: role.textSecondary,
    fontSize: 14,
  },
  editItemInput: {
    borderColor: role.borderControl,
  },
  editItemFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 12,
    borderTopColor: role.borderControl,
    borderTopWidth: 1,
  },
  editItemDeleteButton: {
    color: Colors.red,
    fontWeight: '600',
  },
  // Confirmation modal styles
  confirmOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  confirmContainer: {
    width: 320,
    backgroundColor: role.surface,
    borderRadius: 8,
    padding: 20,
    alignItems: 'center',
  },
  confirmTitle: {
    fontWeight: '700',
    marginBottom: 12,
  },
  confirmBody: {
    textAlign: 'left',
    marginBottom: 16,
    fontSize: 16,
    color: role.textStrong,
  },
  confirmActions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  confirmYes: {
    backgroundColor: Colors.red,
    paddingHorizontal: 20,
    paddingVertical: 8,
    borderRadius: 4,
    flex: 1,
    marginRight: 8,
    alignItems: 'center',
  },
  confirmCancel: {
    backgroundColor: role.fillMuted,
    paddingHorizontal: 20,
    paddingVertical: 8,
    borderRadius: 4,
    flex: 1,
    marginLeft: 8,
    alignItems: 'center',
  },
  confirmYesText: {
    color: Colors.white,
    fontWeight: '500',
  },
  confirmCancelText: {
    color: role.textStrong,
  },
}));
